import React, { useMemo } from "react";
import { PolarArea } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  ArcElement,
  CategoryScale,
  RadialLinearScale,
} from "chart.js";
import { useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

import {
  getLatestWheelData,
  getTotalScore,
  buildChartData,
  buildChartOptions,
  wheelOfLifeLabelsPlugin,
} from "./CustomChart.utils";
import { WHEEL_OF_LIFE_LABEL } from "./CustomChart.constants";
import {
  RootBox,
  HeaderStack,
  HeaderTypography,
  ChartWrapper,
  TotalScoreBox,
  TotalScoreValue,
} from "./CustomChart.styles";

ChartJS.register(
  Title,
  Tooltip,
  ArcElement,
  CategoryScale,
  RadialLinearScale,
  wheelOfLifeLabelsPlugin
);

const CustomChart = () => {
  const theme = useTheme();
  const { userData } = useSelector((state) => state.user);

  const latestWheelData = useMemo(
    () => getLatestWheelData(userData),
    [userData]
  );
  const totalScore = useMemo(
    () => getTotalScore(latestWheelData),
    [latestWheelData]
  );
  const chartData = useMemo(
    () => buildChartData(latestWheelData),
    [latestWheelData]
  );
  const chartOptions = useMemo(
    () => buildChartOptions(theme),
    [theme]
  );

  const formattedDate =
    userData?.wheelOfLife?.length > 0
      ? dayjs(userData.wheelOfLife[0].date).format("MMM DD, YYYY")
      : "No data";

  return (
    <RootBox>
      <HeaderStack direction="row" spacing={2}>
        <HeaderTypography>{WHEEL_OF_LIFE_LABEL}</HeaderTypography>
        <HeaderTypography>{formattedDate}</HeaderTypography>
      </HeaderStack>
      <ChartWrapper>
        <PolarArea data={chartData} options={chartOptions} />
      </ChartWrapper>
      <TotalScoreBox>
        Total Score:{" "}
        <TotalScoreValue component="span">{totalScore}</TotalScoreValue>
      </TotalScoreBox>
    </RootBox>
  );
};

export default CustomChart;
